import SegmentationFiltersUI from './SegmentationFiltersUI';
import SegmentationFiltersJoinedProvider from '../state/SegmentationFiltersJoinedProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export function SegmentationFilters(props) {
  return /*#__PURE__*/_jsx(SegmentationFiltersJoinedProvider, Object.assign({}, props, {
    useOnePanel: false,
    children: /*#__PURE__*/_jsx(SegmentationFiltersUI, {})
  }));
}
export default SegmentationFilters;